import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { getPortalMigrationDetails } from "../../actions";
/**
 * Contains a mapping of old:new account ids
 * This will only be available during the same page load as a migration.
 */

var migratedAccountsReducer = function migratedAccountsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case getPortalMigrationDetails.SUCCESS_TYPE:
      {
        var _payload$data$financi, _payload$data, _payload$data$financi2, _payload$data$financi3;

        var accountsMapping = (_payload$data$financi = payload === null || payload === void 0 ? void 0 : (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : (_payload$data$financi2 = _payload$data.financialPortalById) === null || _payload$data$financi2 === void 0 ? void 0 : (_payload$data$financi3 = _payload$data$financi2.migrationDetails) === null || _payload$data$financi3 === void 0 ? void 0 : _payload$data$financi3.accountsMapping) !== null && _payload$data$financi !== void 0 ? _payload$data$financi : {};
        return _objectSpread(_objectSpread({}, state), accountsMapping);
      }

    default:
      return state;
  }
};

export default migratedAccountsReducer;